const numberFormats = {
    'en-US': {
        currency: {
            style: 'currency',
            currency: 'USD',
            useGrouping: true,
            currencyDisplay: 'symbol',
        },
    },
    'en-UK': {
        currency: {
            style: 'currency',
            currency: 'EUR',
        },
    },
    'ru-RU': {
        currency: {
            style: 'currency',
            currency: 'RUB',
        },
    },
    'en-GB': {
        currency: {
            style: 'currency',
            currency: 'GBP',
        },
    },
}

const customRule = (choice: number, choicesLength: number) => {
    if (choice === 0) {
        return 0
    }
    if (choice === 1) {
        return choicesLength < 3 ? 0 : 1
    }
    return choicesLength < 3 ? 1 : 2
}

export default defineI18nConfig(() => ({
    legacy: false,
    fallbackLocale: 'en',
    numberFormats,
    warnHtmlMessage: false,
    pluralRules: {
        ru: (choice: number, choicesLength: number) => {
            if (choice === 0) {
                return 0
            }
            if (choice % 10 === 1 && choice % 100 !== 11) {
                return 1
            }
            if ([2, 3, 4].includes(choice % 10) && ![12, 13, 14].includes(choice % 100)) {
                return 2
            }
            if (![5, 6, 7, 8, 9].includes(choice % 10) || ![11, 12, 13, 14].includes(choice % 100)) {
                return choicesLength < 4 ? 2 : 3
            }
        },
        en: customRule,
        es: customRule,
        de: customRule,
        ar: customRule,
        fr: customRule,
        it: customRule,
    },
}))
